import React, { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import M from "materialize-css";

import { db } from "../lib/firebaseCompat";
import { useAuth } from "./usehooks.com/use-auth";

const OrganizationContext = createContext();

const initialOrg = {
  name: "",
  id: "",
};

export function ProvideOrganization({ children }) {
  const auth = useAuth();
  const navigate = useNavigate();
  const [orgId, setOrgId] = useState();
  const [current, setCurrentState] = useState(initialOrg);

  const { user } = auth;

  const setCurrent = async (newValue) => {
    if (newValue.id === current.id) return;

    const userRef = db.collection("users").doc(user.uid);
    await userRef.update({ currentOrganization: newValue.id });
    setCurrentState(newValue);
  };

  useEffect(() => {
    if (!user) return;
    (async () => {
      const userRef = db.collection("users").doc(user.uid);
      const userDoc = await userRef.get();
      const currentOrganization = userDoc.get("currentOrganization");
      setOrgId(currentOrganization);
    })();
  }, [user]);

  useEffect(() => {
    if (!orgId) return;

    return db
      .collection("organizations")
      .doc(orgId)
      .onSnapshot(
        (doc) => {
          const org = { ...doc.data(), id: doc.id };
          setCurrent(org);
        },
        (err) => {
          console.log("cannot read current org", err);
          setCurrent({ id: null });
          M.toast({
            html:
              "You can no longer view the selected organization. Please choose a new one.",
          });
          navigate("/account");
        }
      );
  }, [user, orgId]);

  return (
    <OrganizationContext.Provider value={{ current, setCurrent }}>
      {children}
    </OrganizationContext.Provider>
  );
}

ProvideOrganization.propTypes = {
  children: PropTypes.element.isRequired,
};

export const useOrganization = () => {
  return useContext(OrganizationContext);
};
